import React, { useState } from 'react';
import styles from '../AppContent.module.css';
import localStyles from './Notepad.module.css';

export const Notepad: React.FC = () => {
  const [content, setContent] = useState(`Welcome to my portfolio!

I have some great memories playing on my dad's computer, and I've always enjoyed how beautiful windows xp is - this website is to help bring back those memories. In fact I even rooted my phone in middle school to replace the standard icons with windows xp icons. Over winter break (in college) I decided to build something for fun, and this website came to mind.

I hope you enjoy it and your time here!


Thanks for visiting!
`);

  return (
    <div className={styles.appContainer}>
      <div className={localStyles.menuBar}>
        <button className={localStyles.menuItem}>File</button>
        <button className={localStyles.menuItem}>Edit</button>
        <button className={localStyles.menuItem}>Format</button>
        <button className={localStyles.menuItem}>View</button>
        <button className={localStyles.menuItem}>Help</button>
      </div>

      <textarea
        className={localStyles.textarea}
        value={content}
        onChange={(e) => setContent(e.target.value)}
        spellCheck={false}
      />

      <div className={styles.statusBar}>
        Ln 1, Col 1
      </div>
    </div>
  );
};

export default Notepad;
